import React from 'react';
import Router from 'next/router';
import { isEmpty } from 'ramda';

import FullPageModal from '@/components/FullPageModal';
import Heading from '@/components/Heading';
import Text from '@/components/Text';
import useDestination from '@/hooks/useDestination';
import { useDestination as v2UseDestination } from '@/v2/contexts/destination';
import { useIncreaseRange } from '@/v2/hooks/featureFlags/increaseRange/useIncreaseRange';
import useGetPackagesCheapestOffer from '../../hooks/useGetPackagesCheapestOffer';
import usePropertiesContent from '../../hooks/usePropertiesContent';
import Map from './components/Map';
import PreviewProperty from './components/PreviewProperty';
import { PreviewPropertyProvider } from './hooks/usePreviewProperty';

const MapView = React.memo(() => {
  const propertiesContent = usePropertiesContent();
  const d = useDestination();
  const dV2 = v2UseDestination();
  const destination = d || dV2;

  const { searchQuery, loading } = useGetPackagesCheapestOffer();
  const isPostSearch = searchQuery && !isEmpty(searchQuery) && !loading;
  const isIncreaseRangeEnabled = useIncreaseRange();

  return (
    <PreviewPropertyProvider>
      <FullPageModal onClose={() => Router.back()}>
        <PreviewProperty />
        <FullPageModal.Header>
          {/* Show "Top picks header when on destination page and increase range is turned on" */}
          {!destination.theme && isIncreaseRangeEnabled ? (
            <Text hint textStyle="small">
              {`Showing Top Picks for ${destination.title}`}
            </Text>
          ) : (
            <>
              <Heading.h4 pb="1">{destination.title}</Heading.h4>
              {isPostSearch && (
                <Text hint textStyle="small">
                  {`Showing ${propertiesContent.length} packages`}
                </Text>
              )}
            </>
          )}
        </FullPageModal.Header>
        <FullPageModal.Body>
          <Map />
        </FullPageModal.Body>
      </FullPageModal>
    </PreviewPropertyProvider>
  );
});

export default MapView;
